export default "__VITE_ASSET__wGBgINai__"